<template>
  <div class="px-4 flex items-center">
    <IconButton
      class="mr-2"
      :icon-name="IconName.ARROW_LEFT_CIRCLE"
      label="Back"
      :size="ButtonSize.XS"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      @click="emit('back')"
    />
    <h2 v-if="title" class="text-xl font-bold text-secondary">
      {{ props.title }}
    </h2>
  </div>
</template>

<script setup lang="ts">
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconName,
} from '@exfluential/ui';

type Props = {
  title?: string;
};
const props = defineProps<Props>();
const emit = defineEmits(['back']);
</script>
